<template>
  <v-card outlined :loading="loading">
    <v-card-title>
      REPORTE POR CAJERO
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col cols="2" md="2">
          <v-text-field
              type="date"
              label="Desde:"
              v-model="fechaInicial"
              dense
          />
        </v-col>
        <v-col cols="2" md="2">
          <v-text-field
              type="date"
              label="Hasta:"
              v-model="fechaFinal"
              dense
          />
        </v-col>
        <v-col cols="2" md="2">
          <v-select
              label="Tipo:"
              v-model="tipo"
              :items="tipoFacturas"
              item-value="id"
              item-text="text"
              dense
          />
        </v-col>
        <v-col cols="2" md="2">
          <v-text-field
              label="Ventanilla"
              v-model="ventanilla"
              maxlength="5"
              @keypress="patterns.onlyNumber($event)"
              dense
              required
          />
        </v-col>
        <v-col cols="2" md="2">
          <v-btn
              color="accent"
              outlined
              title="Actualizar lista"
              class="mt-1"
              @click="listar()"
              :loading="loading"
              small
          >
            <v-icon small>mdi-update</v-icon>
            Listar
          </v-btn>
        </v-col>
        <v-col cols="1" md="1">
          <v-btn color="blue darken-4" title="Imprimir Reporte" class="mt-1"
            @click="imprimir()" :loading="loading" small icon>
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="1" md="1">
          <v-btn color="green darken-2" title="Descargar Excel" class="mt-1"
            @click="descargarExcel()" :loading="loading" small icon>
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div :id="swPrint">
        <head-report :title="swPrint"/>
        <div class="cuadro" style="text-align: center; border: 2px solid #000; border-radius: 10px; padding: 15px; width: 60%; margin: auto; background-color: #f9f9f9;">
          <h2>Correspondiente a: {{ fechaLiteral }} </h2>
          <h2>De la Caja: {{ detalleCajero }}</h2>
        </div>
      <v-simple-table class="simple-table">
        <thead>
        <tr>
          <th>#</th>
          <th>Fecha</th>
          <th>Factura</th>
          <th>Periodo</th>
          <th>Cliente</th>
          <th>Total (Bs)</th>
          <th>Cajero</th>
          <th>Estado</th>
          <th>Tipo</th>
          <th>Ventanilla</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(factura, index) in facturas" :key="index">
          <td>{{ (pagination.per_page * (pagination.current_page - 1)) + (index + 1) }}</td>
          <td>{{ factura.fecha | localDateHour }}<br><!--<small>{{ factura.hora_pago ? (factura.hora_pago | localDateHourSeconds) : '12:00:00' }}</small></td>-->
          <td>
            Nro. Factura: {{ factura.numero_factura }} <br>
            nfac: {{ factura.nfac }}
          </td>
          <td>{{factura.periodo}}</td>
          <td>
            Cuenta: {{ factura.cuenta }} <br>
            Ci/Nit: {{ factura.ci_nit }} <br>
            Razón social: {{ factura.razon_social }}
          </td>
          <td>
            <span :style="factura.es_conciliado ? 'text-decoration:line-through' : ''">{{factura.total }}</span>
            <span v-if="factura.es_conciliado">
              <br>
              {{factura.monto_conciliado }}
            </span>
          </td>
          <td>
            Ventanilla: {{ factura.cajero.ventanilla }} <br>
            Entidad: {{ factura.entidad }} <br>
            Sucursal: {{ factura.sucursal }}
          </td>
          <td>
            <span v-if="factura.es_anulado" style="color: darkred">Anulado</span>
            <span v-else style="color: green">Vigente</span>
          </td>
          <td>
            {{ factura.tipo }}
            <br>

            <v-chip
                v-if="factura.es_conciliado"
                color="warning"
                small
                text-color="white"
                style="margin-left: -10px"
                dark
            >
              Conciliación
            </v-chip>
          </td>
          <td class="text-center">{{ factura.cajero.ventanilla }}</td>
        </tr>
        </tbody>
      </v-simple-table>

      <v-simple-table class="simple-table mt-4">
        <thead>
        <tr>
          <th>Cajero</th>
          <th>Cantidad de facturas</th>
          <th>Total recaudado (Bs)</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ detalleCajero }}</td>
          <td class="text-center">{{ cantidadFacturas }}</td>
          <td class="text-right pr-4">{{ totalRecaudado }}</td>
        </tr>   
        </tbody>
      </v-simple-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {recaudacionStore} from "@/store/recaudacionStore";
import {ReporteCajeroBancoService} from "@/services/ReporteCajeroBancoService";
import FacturaHistorial from "@/views/facturas/FacturaHistorial.vue";
import { Reporte } from "@/addons/Reporte";
import { Alert } from "@/addons/Alert";
import HeadReport from "@/components/HeadReport.vue";

@Component({
  name: "FacturaIndex",
  components: {FacturaHistorial, HeadReport}
})
export default class FacturaIndex extends Vue {
  private patterns = Pattern;
  private recaudacionStore = recaudacionStore();
  private reporteCajeroBancoService = ReporteCajeroBancoService.getInstance();

  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
  private ventanilla = null;
  private swPrint = 'LISTADO DE RECAUDACIÓN POR CAJERO';

  private facturaSeleccionada: any = null;

  private tipoFacturas = [
    {id: '%', text: 'Todos'},
    {id: 'ConsumoAgua', text: 'Consumo de agua'},
    {id: 'OtroServicio', text: 'Otros ingresos'},
    {id: 'Anulado', text: 'Anulados'},
  ];
  private tipo = '%';

  get fechaLiteral(): string {
    return this.recaudacionStore.fechaLiteral;
  }
  get detalleCajero(): any[] {
    return this.recaudacionStore.detalleCajero;
  }
  get cantidadFacturas(): any[] {
    return this.recaudacionStore.cantidadFacturas;
  }
  get totalRecaudado(): any[] {
    return this.recaudacionStore.totalRecaudado;
  }
  get facturas(): any[] {
    return this.recaudacionStore.facturasCajero;
  }

  get loading(): boolean {
    return this.recaudacionStore.loading;
  }

  get pagination(): any {
    return this.recaudacionStore.pagination;
  }

  get showDialogHistorial(): boolean {
    return this.recaudacionStore.showDialogHistorial;
  }

  mounted() {
    // No cargar datos automáticamente - esperar a que usuario ingrese ventanilla
  }

  imprimir() {
    const p = new Reporte(this.swPrint);
    p.orientacion = 'horizontal';
    p.imprimir();
  }

  listar() {
    if (!this.ventanilla) {
      Alert.info('Por favor ingrese una ventanilla');
      return;
    }
    const data = {
      fechaInicial: this.fechaInicial,
      fechaFinal: this.fechaFinal,
      tipoFactura: this.tipo,
      ventanilla: this.ventanilla
    };
    this.reporteCajeroBancoService.reporteCajeroBanco(data);
  }

  descargarExcel() {
    if (!this.ventanilla) {
      Alert.info('Por favor ingrese una ventanilla');
      return;
    }
    const data = {
      fechaInicial: this.fechaInicial,
      fechaFinal: this.fechaFinal,
      tipoFactura: this.tipo,
      ventanilla: this.ventanilla
    };
    this.reporteCajeroBancoService.descargarReporteBancaMovil(data);
  }

  openHistorial(factura:any) {
    this.facturaSeleccionada = factura;
    this.recaudacionStore.showDialogHistorial = true;

    this.reporteCajeroBancoService.getHistorial(factura.id);
  }

  closeHistorial() {
    this.recaudacionStore.showDialogHistorial = false;
  }
}
</script>

<style scoped>
tr:nth-child(even) {
  background-color: #FAFAFA;
}

.simple-table {
  border: 1px solid #DDDDDD;
}
</style>